import base from './base.css.js';
import { createStyleTag } from './create-style-tag.js';
import { themes } from './themes/index.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const themeStyleTag = createStyleTag();
createStyleTag(base);
let currentTheme;
const updateTheme = /* @__PURE__ */ __name(() => {
  var _a;
  const themeStyle = (_a = themes) == null ? void 0 : _a[currentTheme];
  if (themeStyleTag && themeStyle) {
    themeStyleTag.innerHTML = themeStyle;
  }
}, "updateTheme");
const getTheme = /* @__PURE__ */ __name(() => currentTheme, "getTheme");
const setTheme = /* @__PURE__ */ __name((theme) => {
  currentTheme = theme;
  updateTheme();
}, "setTheme");

export { getTheme, setTheme };
//# sourceMappingURL=theme.js.map
